/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MediaProcessingStatusFromJSON, MediaProcessingStatusToJSON, } from './MediaProcessingStatus';
import { UserIncidentFootageMarkerDtoFromJSON, UserIncidentFootageMarkerDtoToJSON, } from './UserIncidentFootageMarkerDto';
/**
 * Check if a given object implements the UserIncidentFootageDto interface.
 */
export function instanceOfUserIncidentFootageDto(value) {
    let isInstance = true;
    return isInstance;
}
export function UserIncidentFootageDtoFromJSON(json) {
    return UserIncidentFootageDtoFromJSONTyped(json, false);
}
export function UserIncidentFootageDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'discriminator': !exists(json, 'discriminator') ? undefined : json['discriminator'],
        'uploadFileName': !exists(json, 'uploadFileName') ? undefined : json['uploadFileName'],
        'uploadMimeType': !exists(json, 'uploadMimeType') ? undefined : json['uploadMimeType'],
        'isUploaded': !exists(json, 'isUploaded') ? undefined : json['isUploaded'],
        'uploadFileSize': !exists(json, 'uploadFileSize') ? undefined : json['uploadFileSize'],
        'uploadBucket': !exists(json, 'uploadBucket') ? undefined : json['uploadBucket'],
        'uploadObjectKey': !exists(json, 'uploadObjectKey') ? undefined : json['uploadObjectKey'],
        'uploadUrl': !exists(json, 'uploadUrl') ? undefined : json['uploadUrl'],
        'downloadUrl': !exists(json, 'downloadUrl') ? undefined : json['downloadUrl'],
        'userProfileId': !exists(json, 'userProfileId') ? undefined : json['userProfileId'],
        'mediaProcessingStatus': !exists(json, 'mediaProcessingStatus') ? undefined : MediaProcessingStatusFromJSON(json['mediaProcessingStatus']),
        'thumbnailUrl': !exists(json, 'thumbnailUrl') ? undefined : json['thumbnailUrl'],
        'previewUrl': !exists(json, 'previewUrl') ? undefined : json['previewUrl'],
        'markers': !exists(json, 'markers') ? undefined : (json['markers'] === null ? null : json['markers'].map(UserIncidentFootageMarkerDtoFromJSON)),
    };
}
export function UserIncidentFootageDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'discriminator': value.discriminator,
        'uploadFileName': value.uploadFileName,
        'uploadMimeType': value.uploadMimeType,
        'isUploaded': value.isUploaded,
        'uploadFileSize': value.uploadFileSize,
        'uploadBucket': value.uploadBucket,
        'uploadObjectKey': value.uploadObjectKey,
        'uploadUrl': value.uploadUrl,
        'downloadUrl': value.downloadUrl,
        'userProfileId': value.userProfileId,
        'mediaProcessingStatus': MediaProcessingStatusToJSON(value.mediaProcessingStatus),
        'thumbnailUrl': value.thumbnailUrl,
        'previewUrl': value.previewUrl,
        'markers': value.markers === undefined ? undefined : (value.markers === null ? null : value.markers.map(UserIncidentFootageMarkerDtoToJSON)),
    };
}
